module.exports = __webpack_public_path__ + "img/1.572da98d.jpeg";